export const VIDEO_URL = '/videos/alizee.mp4';
